import {baseApi} from "@/utils/api.js";

const activeUserApi = baseApi.enhanceEndpoints({
  addTagTypes: ['ActiveUser'],
}).injectEndpoints({
  endpoints: (builder) => ({
    getProfile: builder.query({
      query: () => ({
        url: '/users/me',
        method: 'GET',
      }),
      providesTags: ['ActiveUser'],
    }),
    createProfile: builder.mutation({
      query: ({ data }) => ({
        url: '/users/me',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['ActiveUser', 'Households'],
    }),
    updateProfile: builder.mutation({
      query: ({ data }) => ({
        url: '/users/me',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['ActiveUser'],
    }),
  }),
});

export const {
  useGetProfileQuery,
  useCreateProfileMutation,
  useUpdateProfileMutation,
} = activeUserApi;
